<div class="filters-wrapper justify-content-between align-items-center px-4">
  <div class="filters-wrapper-left">
    <div
      class="btn-group"
      [isDisabled]="!selectedInvites.length"
      dropdown
      [autoClose]="true"
      placement="bottom left"
    >
      <button
        dropdownToggle
        type="button"
        class="btn btn-primary dropdown-toggle"
        aria-controls="actions-dropdown"
        [ngClass]="{ disabled: !selectedInvites.length }"
      >
        Actions <span class="caret"></span>
      </button>
      <ul
        id="actions-dropdown"
        *dropdownMenu
        class="dropdown-menu dropdown-menu-left"
        role="menu"
        aria-labelledby="button-basic"
        style="z-index: 999999"
      >
        <li>
          <a class="dropdown-item" (click)="resendInvites()"> Re-send invite</a>
        </li>
        <li *ngIf="selectedInvites.length === 1">
          <a class="dropdown-item" (click)="copyInviteLink()">
            Copy Invite Link</a
          >
        </li>
        <li>
          <a
            class="dropdown-item"
            (click)="removeInvites(removeInviteConfirmation)"
          >
            Remove Invites</a
          >
        </li>
      </ul>
    </div>
  </div>
  <div class="dropdown-workspace-filter">
    <span dropdown [autoClose]="true">
      <div dropdownToggle>
        <i class="feather user"></i>
        <span class="sort-by">{{
          dashboardService.filters()[dashboardName].workspaceFilter.label
        }}</span>
        <i class="feather chevron-down"></i>
      </div>
      <ul
        *dropdownMenu
        class="dropdown-menu"
        aria-labelledby="dLabel"
        role="menu"
      >
        <li role="menuitem">
          <a
            class="dropdown-item"
            (click)="changeWorkspaceFilter('All Workspaces', null)"
            >All Workspaces</a
          >
        </li>
        <hr />
        <li
          role="menuitem"
          *ngFor="let workspace of dashboardStore.clients | activeClientsOnly"
        >
          <a
            class="dropdown-item"
            (click)="changeWorkspaceFilter(workspace.name, workspace.uuid)"
            >{{ workspace.name }}</a
          >
        </li>
      </ul>
    </span>
  </div>
</div>

<p-table
  #dt
  [value]="invites"
  [columns]="cols"
  [rowHover]="true"
  [sortOrder]="sortOrder"
  [sortField]="sortField"
  dataKey="email"
  styleClass="job-list"
  [(selection)]="selectedInvites"
  [rows]="dashboardService.filters()[dashboardName].rows || 25"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
  responsiveLayout="scroll"
  [paginator]="true"
  [resizableColumns]="true"
  [lazy]="true"
  columnResizeMode="fit"
  [totalRecords]="totalRecords"
  (onLazyLoad)="getDashboardData($event)"
  [loading]="loading"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  scrollHeight="calc(100vh - 254px)"
  selectionMode="multiple"
>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="columns.length + 1">
        <div class="empty-dashboard-row-content">
          <ds-empty-state></ds-empty-state>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 3rem">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <th
        *ngFor="let col of cols"
        [pResizableColumn]="col.field"
        [pSortableColumn]="col.field !== 'workspace' ? col.field : null"
        (click)="
          changeSortByFilter(col.field === 'workspace' ? null : col.field, 1)
        "
      >
        {{ col.header }}
        <p-sortIcon
          *ngIf="col.field !== 'workspace'"
          [field]="col.field"
        ></p-sortIcon>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-invite let-columns="columns">
    <tr [pSelectableRow]="invite">
      <td>
        <p-tableCheckbox [value]="invite"></p-tableCheckbox>
      </td>
      <td *ngFor="let col of columns">
        <ng-container [ngSwitch]="col.field">
          <span *ngSwitchCase="'created'">
            {{ invite.created | amFromUtc | amDateFormat: "MMM Do, YYYY" }}
          </span>
          <span *ngSwitchDefault>{{ invite[col.field] }}</span>
        </ng-container>
      </td>
    </tr>
  </ng-template>
</p-table>

<ng-template #removeInviteConfirmation>
  <div class="modal-body text-center rounded">
    <div>
      <h4>Are you sure?</h4>
      <p *ngIf="selectedInvites.length <= 1">
        Do you really want to remove this invite? The user will not be able to
        join this company anymore.
      </p>
      <p *ngIf="selectedInvites.length > 1">
        Do you really want to remove these invites? The users will not be able
        to join this company anymore.
      </p>
    </div>

    <div class="row">
      <div class="col-6">
        <button
          type="button"
          class="btn btn-danger pull-left btn-block"
          (click)="confirmInvitesRemoval(invite_being_removed)"
        >
          Remove
        </button>
      </div>
      <div class="col-6">
        <button
          type="button"
          class="btn btn-default pull-right btn-block"
          (click)="modalRef.hide()"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>
